import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type IFT_012_2019Props = {};

const IFT_012_2019: React.FC<IFT_012_2019Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='IFT-012-2019'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                IFT-012-2019
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "non_ionizing_emissions",
                    defaultMessage: "Technical specifications for compliance with the maximum limits of non-ionizing radioelectric emissions of products, equipment, devices or apparatus intended for telecommunications that can be connected to a telecommunications network and/or make use of the radioelectric spectrum. Specific Absorption Rate (SAR)."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "non_ionizing_emissions_2",
                    defaultMessage: "Products, equipment, devices or appliances that have a radio frequency transmitter or transceiver, make use of the radio spectrum or are connected to a telecommunications network in the frequency range of 30 MHz to 6 GHz and that are used:"
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "non_ionizing_emissions_3",
                    defaultMessage: "a) Near the head, particularly near the ear, in the frequency range of 300 MHz to 6 GHz, and/or"
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "non_ionizing_emissions_4",
                    defaultMessage: "b) At a distance less than or equal to 200 mm from the human body, in the frequency range of 30 MHz to 6 GHz"
                  })
                }
              </p>
            </div>
            
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-md w-full" src="/img/mobile-devices.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IFT_012_2019;